import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EmailPackage } from './email-package'

import { EmailAuditPackages, EmailMessages} from '../../../../core';
import { ReturnStatement } from '@angular/compiler';

@Component({
  selector: 'email-tree',
  templateUrl: './email-tree.component.html',
  styleUrls: ['./email-tree.component.scss']
})
export class EmailTreeComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
  @Input() data: EmailAuditPackages[];
  @Input() auditType: string;
  @Output() selectRecipient = new EventEmitter<EmailAuditPackages>();
  @Output() selectProperty = new EventEmitter<EmailMessages>();
  @Output() toggleProperty = new EventEmitter<EmailMessages>();
  @Output() updateNotificationPackage = new EventEmitter<EmailMessages[]>();

  noIcons:string="";

  TitleRecipient(item:EmailAuditPackages):string{
    let txt = "-";
    if (item.Sent) {
      txt = item.DeliveredSuccessful?"Email delivery successful":item.DeliveryFailed?"Email delivery failed":"Email was sent"
    }
    else{
      txt = item.SendEnabled?`Email is selected`:'Email isn\'t selected';
    }
    return txt;
  }

  GetRecipientClassStr(item:EmailAuditPackages):string{
    let txt = "-";
    if (item.Sent) {
      txt = item.DeliveredSuccessful?"cvt-svg-email-delivered":item.DeliveryFailed?"cvt-svg-email-failed":"cvt-svg-email-sent"
    }
    else{
      txt = item.SendEnabled?`cvt-icon-htmlEmailFilled sizeGlyph`:'cvt-svg-inactive';
    }
    return txt;
  }

  toggleExpand(i:number, ev){
    this.data[i].expanded = this.data[i].expanded?false:true;
  }
  toggleSendMail(i:number){
    let item = this.data[i];
    if(!item.Sent){
      let SendEnabled = item.SendEnabled?false:true;
      item.SendEnabled = SendEnabled;
      let msgs = item.EmailMessages;
      msgs.forEach(msg=> msg.IncludeInPackage = SendEnabled);
      this.updateNotificationPackage.emit(msgs);
    }
  }
  toggleSendToHotel(i:number, j:number){
    if(!this.data[i].Sent){
      var item = this.data[i].EmailMessages[j];
      this.toggleProperty.emit(item);
    }
  }
  clickRecipient(i:number){
    var item = this.data[i];
    if(item.EmailMessages.length>0){
      this.selectRecipient.emit(item);
    }
    if(this.auditType=='reverseAudit'){
      this.selectRecipient.emit(item);
    }
  }
  clickProperty(property:EmailMessages){
    this.selectProperty.emit(property);
  }
  getRecipientDispayText(item:EmailAuditPackages){
    var l = item.EmailMessages.filter(em => em.IncludeInPackage == true).length;
    if(l <= 0){
      return item.ToEMailAddress;
    }else{
      return item.ToEMailAddress + " ("+l+")";
    }
  }
  getClassStr(SendEnabled:boolean, item:any){
    let selected = item.selected?true:false;
    if(this.auditType!="reverseAudit"){
    return selected?(!SendEnabled?'disableSelected':'enableSelected'):(!SendEnabled?'disable':'enable');
    }
    else{
      return 'enable';
    }

  }
}

